// AUTO-GENERATED by scripts/inject-build-info.js — do not edit manually
export const BUILD_INFO = {
  commitHash: 'a10e91e8385b43ca54c61cfd57f6732502589c4f',
  buildTime: '2026-06-17T15:41:44.551Z',
} as const;
